import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './Edit.less';
import HwzComponent from '../../common/component/HwzComponent';
import User from '../../common/model/user/User';
import Moon from '../../common/model/global/Moon';
import JsonUtil from '../../common/util/JsonUtil'; // 确保这行存在
import HwzTitle from '../widget/HwzTitle';
import { Button, Form, Input, InputNumber, Switch, Tag, Modal, Upload, message, Row, Col, Card, Select } from 'antd';
import { SaveOutlined, ImportOutlined, ExportOutlined, DeleteOutlined, EyeOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import HwzContentCard from '../widget/HwzContentCard';
import Preference from '../../common/model/preference/Preference';
import { FormInstance } from 'antd/lib/form';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import Sun from '../../common/model/global/Sun';
import Lang from '../../common/model/global/Lang';
import MatterImage from '../matter/widget/MatterImage';
import InputSize from '../widget/form/InputSize';

const { Option } = Select;

interface IProps extends RouteComponentProps {}

interface IState {
  sensitiveWords: string[];
  showSensitiveWordsModal: boolean;
  newSensitiveWord: string;
  forbiddenExtensions: string[];
  showForbiddenExtensionsModal: boolean;
  newForbiddenExtension: string;
  showWatermarkModal: boolean;
  watermarkConfig: {
    enabled: boolean;
    text: string;
    fontSize: number;
    color: string;
    opacity: number;
    rotate: number;
    showUser: boolean;
    pdfText: string;
    pdfColor: string;
    imageText: string;
    imageOpacity: number;
    documentText: string;
  };
  // 新增：病毒库更新相关状态
  updatingVirusDb: boolean;
  uploadingVirusDb: boolean;
}

// 预定义颜色选项 - 使用国际化
const getColorOptions = () => {
  return [
    { value: 'rgba(128, 128, 128, 0.3)', label: Lang.t('color.grayTransparent'), color: 'rgba(128, 128, 128, 0.3)' },
    { value: 'rgba(255, 0, 0, 0.2)', label: Lang.t('color.redTransparent'), color: 'rgba(255, 0, 0, 0.2)' },
    { value: 'rgba(0, 0, 255, 0.2)', label: Lang.t('color.blueTransparent'), color: 'rgba(0, 0, 255, 0.2)' },
    { value: 'rgba(0, 128, 0, 0.2)', label: Lang.t('color.greenTransparent'), color: 'rgba(0, 128, 0, 0.2)' },
    { value: 'rgba(255, 165, 0, 0.2)', label: Lang.t('color.orangeTransparent'), color: 'rgba(255, 165, 0, 0.2)' },
    { value: 'rgba(128, 0, 128, 0.2)', label: Lang.t('color.purpleTransparent'), color: 'rgba(128, 0, 128, 0.2)' },
    { value: 'rgba(0, 0, 0, 0.3)', label: Lang.t('color.blackTransparent'), color: 'rgba(0, 0, 0, 0.3)' },
    { value: 'rgba(255, 255, 255, 0.3)', label: Lang.t('color.whiteTransparent'), color: 'rgba(255, 255, 255, 0.3)' },
  ];
};

export default class Edit extends HwzComponent<IProps, IState> {
  formRef = React.createRef<FormInstance>();

  user: User = Moon.getSingleton().user;
  preference: Preference = Moon.getSingleton().preference;

  constructor(props: IProps) {
    super(props);

    this.state = {
      sensitiveWords: [],
      showSensitiveWordsModal: false,
      newSensitiveWord: '',
      forbiddenExtensions: [],
      showForbiddenExtensionsModal: false,
      newForbiddenExtension: '',
      showWatermarkModal: false,
      watermarkConfig: {
        enabled: false,
        text: Lang.t('preference.defaultWatermarkText'),
        fontSize: 36,
        color: 'rgba(128, 128, 128, 0.3)',
        opacity: 0.3,
        rotate: -30,
        showUser: false,
        pdfText: Lang.t('preference.defaultPdfWatermarkText'),
        pdfColor: 'rgba(255, 0, 0, 0.2)',
        imageText: Lang.t('preference.defaultImageWatermarkText'),
        imageOpacity: 0.2,
        documentText: Lang.t('preference.defaultDocumentWatermarkText')
      },
      // 新增状态初始化
      updatingVirusDb: false,
      uploadingVirusDb: false
    };

    this.preference.detailLoading = true;
  }

  componentDidMount() {
    let that = this;

    that.refreshPreference();
  }

  refreshPreference() {
    let that = this;
  
    that.preference.httpFetch(function () {
      that.preference.detailLoading = false;
      
      // 初始化敏感词
      if (that.preference.forbiddenKeywords) {
        that.setState({
          sensitiveWords: that.preference.forbiddenKeywords.split(',').filter(word => word.trim() !== '')
        });
      }
      
      // 初始化禁止扩展名
      if (that.preference.forbiddenExtensions) {
        that.setState({
          forbiddenExtensions: that.preference.forbiddenExtensions.split(',').filter(ext => ext.trim() !== '')
        });
      }
  
      // 初始化水印配置
      if (that.preference.watermarkConfig) {
        const watermarkConfig = that.preference.watermarkConfig;
        that.setState({
          watermarkConfig: {
            enabled: watermarkConfig.enabled || false,
            text: watermarkConfig.text || Lang.t('preference.defaultWatermarkText'),
            fontSize: watermarkConfig.fontSize || 36,
            color: watermarkConfig.color || 'rgba(128, 128, 128, 0.3)',
            opacity: watermarkConfig.opacity || 0.3,
            rotate: watermarkConfig.rotate || -30,
            showUser: watermarkConfig.showUser || false,
            pdfText: watermarkConfig.pdfText || Lang.t('preference.defaultPdfWatermarkText'),
            pdfColor: watermarkConfig.pdfColor || 'rgba(255, 0, 0, 0.2)',
            imageText: watermarkConfig.imageText || Lang.t('preference.defaultImageWatermarkText'),
            imageOpacity: watermarkConfig.imageOpacity || 0.2,
            documentText: watermarkConfig.documentText || Lang.t('preference.defaultDocumentWatermarkText')
          }
        });
      }
      
      that.updateUI();
    });
  }

  onFinish(values: any) {
    let that = this;
    let user = that.user;
    that.preference.assign(values);
    
    // 新增：检查版本号是否为空
    if (!that.preference.version) {
      MessageBoxUtil.warning(Lang.t('preference.versionEmpty', '版本号不能为空'));
      return;
    }
    
    // 保存敏感词
    that.preference.forbiddenKeywords = that.state.sensitiveWords.join(',');
    
    // 保存禁止扩展名
    that.preference.forbiddenExtensions = that.state.forbiddenExtensions.join(',');
  
    // 调试：打印当前水印配置状态
    console.log('=== 水印配置调试 ===');
    console.log('当前状态中的水印配置:', that.state.watermarkConfig);
    console.log('enabled:', that.state.watermarkConfig.enabled);
    console.log('showUser:', that.state.watermarkConfig.showUser);
  
    // 保存水印配置 - 确保使用当前状态的值
    that.preference.watermarkConfig.assign(that.state.watermarkConfig);
  
    // 调试：打印将要保存的水印配置
    console.log('Preference中的水印配置:', that.preference.watermarkConfig);
    const watermarkConfigToSave = that.preference.watermarkConfig.getForm();
    console.log('将要发送的JSON:', JSON.stringify(watermarkConfigToSave));
    console.log('=== 调试结束 ===');
  
    // 先保存基本设置
    that.preference.httpSave(function () {
      // 基本设置保存成功后，再保存水印配置
      // 传入更新后的水印配置
      that.preference.httpSaveWatermarkConfig(
        watermarkConfigToSave, // 传入实际要保存的配置
        function () {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
          Sun.updateFrame();
          Sun.navigateTo('/preference/index');
        }, 
        function (error: any) {
          console.error('保存水印配置失败:', error);
          MessageBoxUtil.success(Lang.t('preference.watermarkSavePartialSuccess'));
          Sun.updateFrame();
          Sun.navigateTo('/preference/index');
        }
      );
    });
  }
  onFinishFailed(errorInfo: any) {}

  // 添加敏感词
  addSensitiveWord = () => {
    const { newSensitiveWord, sensitiveWords } = this.state;
    if (newSensitiveWord.trim() && !sensitiveWords.includes(newSensitiveWord.trim())) {
      this.setState({
        sensitiveWords: [...sensitiveWords, newSensitiveWord.trim()],
        newSensitiveWord: ''
      });
    }
  };

  // 删除敏感词
  removeSensitiveWord = (wordToRemove: string) => {
    this.setState({
      sensitiveWords: this.state.sensitiveWords.filter(word => word !== wordToRemove)
    });
  };

  // 添加禁止扩展名
  addForbiddenExtension = () => {
    const { newForbiddenExtension, forbiddenExtensions } = this.state;
    if (newForbiddenExtension.trim() && !forbiddenExtensions.includes(newForbiddenExtension.trim())) {
      this.setState({
        forbiddenExtensions: [...forbiddenExtensions, newForbiddenExtension.trim().toLowerCase()],
        newForbiddenExtension: ''
      });
    }
  };

  // 删除禁止扩展名
  removeForbiddenExtension = (extensionToRemove: string) => {
    this.setState({
      forbiddenExtensions: this.state.forbiddenExtensions.filter(ext => ext !== extensionToRemove)
    });
  };

  // 导出敏感词CSV
  exportSensitiveWords = () => {
    const { sensitiveWords } = this.state;
    if (sensitiveWords.length === 0) {
      message.warning(Lang.t('preference.noSensitiveWordsToExport'));
      return;
    }

    const csvContent = "data:text/csv;charset=utf-8," + sensitiveWords.join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "sensitive_words.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 导出扩展名CSV
  exportForbiddenExtensions = () => {
    const { forbiddenExtensions } = this.state;
    if (forbiddenExtensions.length === 0) {
      message.warning(Lang.t('preference.noForbiddenExtensionsToExport'));
      return;
    }

    const csvContent = "data:text/csv;charset=utf-8," + forbiddenExtensions.join('\n');
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "forbidden_extensions.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


// 处理敏感词文件上传
handleSensitiveWordsFileUpload = (file: File) => {
  
  if (!file.name.toLowerCase().endsWith('.csv')) {
    message.error(Lang.t('preference.onlyCsvFilesAllowed'));
    return false;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    const text = e.target?.result;
  
    if (typeof text !== 'string') {
      message.error(Lang.t('preference.fileReadFailed'));
      return;
    }
  
    const words = text
      .split('\n')
      .map(word => word.trim())
      .filter(word => word !== '');
  
    if (words.length === 0) {
      message.warning(Lang.t('preference.noValidWordsFound'));
      return;
    }
  
    // 合并并去重（保持顺序）
    const allWords = [...this.state.sensitiveWords, ...words];
    const uniqueWords = allWords.filter((word, index, self) => 
      self.indexOf(word) === index
    );
  
    this.setState({ sensitiveWords: uniqueWords }, () => {
      // 可选：触发 UI 更新回调（如果你有这个方法）
      if (typeof this.updateUI === 'function') {
        this.updateUI();
      }
  
      const count = words.length;
      
      // 尝试使用 Lang.t 的参数传递模式
      try {
        const count = words.length;
        // 先用 Lang.t 获取字符串，再手动替换
        const rawMessage = Lang.t('preference.sensitiveWordsImported');
        const successMessage = String(rawMessage).replace(/\{count\}/g, count.toString());
        message.success(successMessage);

      } catch (error) {
        // 方法2：如果参数传递失败，使用字符串替换
        const rawMessage = Lang.t('preference.sensitiveWordsImported');
        let successMessage: string;
        
        if (typeof rawMessage === 'string') {
          successMessage = rawMessage.replace(/\{count\}/g, count.toString());
        } else {
          successMessage = String(rawMessage).replace(/\{count\}/g, count.toString());
        }
        
        // 方法3：如果替换失败，使用模板字符串
        if (successMessage.includes('{count}')) {
          successMessage = `成功导入 ${count} 个敏感字`;
        }
        
        message.success(successMessage);
      }
    });
  };
  reader.onerror = (error) => {
    console.error('文件读取错误:', error);
    message.error(Lang.t('preference.importFailed'));
  };
  reader.readAsText(file);
  
  return false;
};
  // 更新水印配置
  updateWatermarkConfig = (key: string, value: any) => {
    this.setState({
      watermarkConfig: {
        ...this.state.watermarkConfig,
        [key]: value
      }
    });
  };

  // 预览水印效果
  previewWatermark = () => {
    const { watermarkConfig } = this.state;
    const previewStyle = {
      position: 'relative' as const,
      width: '400px',
      height: '300px',
      border: '1px solid #d9d9d9',
      background: 'white',
      margin: '20px auto',
      overflow: 'hidden'
    };

    const watermarkStyle = {
      position: 'absolute' as const,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      fontSize: `${watermarkConfig.fontSize}px`,
      color: watermarkConfig.color,
      opacity: watermarkConfig.opacity,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transform: `rotate(${watermarkConfig.rotate}deg)`,
      pointerEvents: 'none' as const,
      whiteSpace: 'nowrap' as const
    };

    Modal.info({
      title: Lang.t('preference.watermarkPreview'),
      width: 500,
      content: (
        <div style={previewStyle}>
          <div style={watermarkStyle}>
            {watermarkConfig.text}
          </div>
          <div style={{ 
            padding: '20px', 
            textAlign: 'center',
            color: '#666'
          }}>
            {Lang.t('preference.watermarkPreviewContent')}
          </div>
        </div>
      )
    });
  };
// 新增：直接处理文件上传的方法
handleFileUpload = (file: File) => {
  console.log('=== 直接文件上传 ===');
  console.log('文件名:', file.name);
  console.log('文件类型:', file.type);
  
  if (!file.name.toLowerCase().endsWith('.csv')) {
    message.error(Lang.t('preference.onlyCsvFilesAllowed'));
    return false;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    const text = e.target?.result;

    
    if (typeof text === 'string') {
      const extensions = text.split('\n')
        .map(ext => ext.trim().toLowerCase())
        .filter(ext => {
          const isValid = ext !== '' && 
                 ext !== 'extension' && 
                 !ext.includes('data:text/csv') &&
                 !ext.includes(',') &&
                 ext.length > 0 &&
                 !ext.startsWith('.') && // 确保没有点号
                 /^[a-z0-9]+$/.test(ext); // 只允许字母数字
          console.log(`扩展名 "${ext}" 是否有效:`, isValid);
          return isValid;
        });

      console.log('解析出的扩展名:', extensions);
      
      if (extensions.length === 0) {
        message.warning(Lang.t('preference.noValidExtensionsFound'));
        return;
      }
      
      // 使用传统方法去重
      const allExtensions = [...this.state.forbiddenExtensions, ...extensions];
      const uniqueExtensions = allExtensions.filter((ext, index, self) => 
        self.indexOf(ext) === index
      );

      console.log('去重后的扩展名:', uniqueExtensions);
      console.log('更新前状态:', this.state.forbiddenExtensions);
      this.setState({ 
        forbiddenExtensions: uniqueExtensions
      }, () => {
        console.log('更新后状态:', this.state.forbiddenExtensions);
        console.log('调用 updateUI()');
        this.updateUI();
        
        // 获取原始消息并确保是字符串
        const rawMessage = Lang.t('preference.forbiddenExtensionsImported');
        let successMessage = String(rawMessage);
        
        // 使用多种方式确保替换成功
        successMessage = successMessage
          .replace(/\{count\}/g, extensions.length.toString())
          .replace(/{count}/g, extensions.length.toString());
        
        // 如果还有占位符，使用备用方案
        if (successMessage.includes('{count}') || successMessage.includes('{count}')) {
          successMessage = successMessage.replace('{count}', extensions.length.toString());
        }
        
        console.log('成功消息:', successMessage);
        message.success(successMessage);
        
        console.log('=== 导入完成 ===');
        
        if (this.state.showForbiddenExtensionsModal) {
          setTimeout(() => {
            this.setState({ 
              showForbiddenExtensionsModal: false 
            }, () => {
              setTimeout(() => {
                this.setState({ 
                  showForbiddenExtensionsModal: true 
                });
              }, 50);
            });
          }, 500);
        }
      });
    }
  };
  reader.onerror = (error) => {
    message.error(Lang.t('preference.importFailed'));
  };
  reader.readAsText(file);
  
  return false; // 阻止默认上传
};

  // 自定义颜色选择器渲染
  renderColorSelect = () => {
    const colorOptions = getColorOptions();
    
    return (
      <Select
        value={this.state.watermarkConfig.color}
        onChange={(value) => this.updateWatermarkConfig('color', value)}
        className="w200"
        dropdownRender={menu => (
          <div>
            {menu}
            <div style={{ padding: '8px', borderTop: '1px solid #d9d9d9' }}>
              <Input 
                placeholder={Lang.t('preference.customColorPlaceholder')}
                onPressEnter={(e: any) => {
                  const value = e.target.value;
                  if (value && this.isValidColor(value)) {
                    this.updateWatermarkConfig('color', value);
                  } else {
                    message.warning(Lang.t('preference.invalidColorFormat'));
                  }
                }}
              />
            </div>
          </div>
        )}
      >
        {colorOptions.map(color => (
          <Option key={color.value} value={color.value}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div 
                style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: color.color,
                  marginRight: '8px',
                  border: '1px solid #d9d9d9'
                }}
              />
              {color.label}
            </div>
          </Option>
        ))}
      </Select>
    );
  };

  // PDF颜色选择器渲染
  renderPdfColorSelect = () => {
    const colorOptions = getColorOptions();
    
    return (
      <Select
        value={this.state.watermarkConfig.pdfColor}
        onChange={(value) => this.updateWatermarkConfig('pdfColor', value)}
        className="w200"
        dropdownRender={menu => (
          <div>
            {menu}
            <div style={{ padding: '8px', borderTop: '1px solid #d9d9d9' }}>
              <Input 
                placeholder={Lang.t('preference.customColorPlaceholder')}
                onPressEnter={(e: any) => {
                  const value = e.target.value;
                  if (value && this.isValidColor(value)) {
                    this.updateWatermarkConfig('pdfColor', value);
                  } else {
                    message.warning(Lang.t('preference.invalidColorFormat'));
                  }
                }}
              />
            </div>
          </div>
        )}
      >
        {colorOptions.map(color => (
          <Option key={color.value} value={color.value}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div 
                style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: color.color,
                  marginRight: '8px',
                  border: '1px solid #d9d9d9'
                }}
              />
              {color.label}
            </div>
          </Option>
        ))}
      </Select>
    );
  };

  // 验证颜色格式
  isValidColor = (color: string): boolean => {
    const rgbaRegex = /^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(,\s*[\d.]+\s*)?\)$/;
    return rgbaRegex.test(color);
  };

  // ==================== 新增：病毒库管理相关方法 ====================
  
// 手动调用 freshclam 更新病毒库
handleManualUpdate = () => {
  const that = this;
  that.setState({ updatingVirusDb: true });
  
  that.preference.httpPost(
      Preference.URL_API_UPDATE_VIRUS_DATABASE,
      {},
      () => {
          // 请求成功即认为任务已启动，不检查 res.code
          message.success(Lang.t('preference.virusDbUpdateSuccess'));
          that.setState({ updatingVirusDb: false });
      },
      (err: any) => {
          console.error('启动病毒库更新失败:', err);
          message.error(Lang.t('preference.virusDbUpdateFailed'));
          that.setState({ updatingVirusDb: false });
      }
  );
};
  
  // 上传病毒库压缩包
// 上传病毒库压缩包
handleUploadVirusDb = (file: File) => {
  const that = this;
  const isZip = file.name.endsWith('.zip') || 
                file.name.endsWith('.tar.gz') || 
                file.name.endsWith('.tgz');
  
  if (!isZip) {
      message.error(Lang.t('preference.invalidVirusDbPackage'));
      return false;
  }
  
  const formData = new FormData();
  formData.append('file', file);
  
  that.setState({ uploadingVirusDb: true });
  
  that.preference.httpUpload(
      Preference.URL_API_UPLOAD_VIRUS_DATABASE,
      formData,
      () => {
          // 请求成功即认为上传解压任务已启动
          message.success(Lang.t('preference.virusDbUploadSuccess'));
          that.setState({ uploadingVirusDb: false });
      },
      (err: any) => {
          console.error('上传病毒库失败:', err);
          message.error(Lang.t('preference.virusDbUploadFailed'));
          that.setState({ uploadingVirusDb: false });
      }
  );
  
  return false;
};
  // ==================== 渲染部分 ====================
  
  render() {
    let that = this;

    let preference = that.preference;

    const layout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
    };

    let initialValues: any = preference.getForm();

    return (
      <div className="page-preference-edit">
        <HwzTitle name={Lang.t('preference.editPreference')} />

        <HwzContentCard loading={preference.detailLoading}>
          <Form
            name="basic"
            ref={this.formRef}
            initialValues={initialValues}
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed.bind(this)}
            onValuesChange={() => that.updateUI()}
          >
            <Row gutter={24}>
              {/* 第一列：基础设置 */}
              <Col span={12}>
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.websiteName')}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: Lang.t('preference.enterWebsiteName'),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item {...layout} label={Lang.t('preference.logo')} name="logoUrl">
                  <MatterImage uploadHint={Lang.t('preference.logoSquare')} />
                </Form.Item>

                <Form.Item {...layout} label={Lang.t('preference.favicon')} name="faviconUrl">
                  <MatterImage
                    filter=".ico"
                    previewWidth={60}
                    uploadHint={Lang.t('preference.onlyAllowIco')}
                  />
                </Form.Item>

                <Form.Item
                  {...layout}
                  label={Lang.t('preference.zipMaxNumLimit')}
                  name="downloadDirMaxNum"
                  rules={[
                    {
                      required: true,
                      message: Lang.t('preference.enterZipMaxNumLimit'),
                    },
                  ]}
                >
                  <InputNumber min={-1} max={1000} className="w150" />
                </Form.Item>

                <Form.Item
                  {...layout}
                  label={Lang.t('preference.zipMaxSizeLimit')}
                  required={true}
                  name="downloadDirMaxSize"
                  rules={[
                    {
                      required: true,
                      message: Lang.t('preference.enterZipMaxSizeLimit'),
                    },
                  ]}
                >
                  <InputSize className="w200" />
                </Form.Item>

                <Form.Item
                  {...layout}
                  label={Lang.t('preference.userDefaultSizeLimit')}
                  required={true}
                  name="defaultTotalSizeLimit"
                  rules={[
                    {
                      required: true,
                      message: Lang.t('preference.enterUserDefaultSizeLimit'),
                    },
                  ]}
                >
                  <InputSize className="w200" />
                </Form.Item>

                <Form.Item
                  {...layout}
                  label={Lang.t('preference.matterBinDefaultSaveDay')}
                  required={true}
                >
                  <Form.Item
                    name="deletedKeepDays"
                    rules={[
                      {
                        required: true,
                        message: Lang.t('preference.enterMatterBinDefaultSaveDay'),
                      },
                    ]}
                    noStyle
                  >
                    <InputNumber min={0} className="w150" />
                  </Form.Item>
                  <span className="pl10">
                    {Lang.t('preference.matterBinDefaultTip')}
                  </span>
                </Form.Item>

                <Form.Item
                  {...layout}
                  label={Lang.t('preference.allowRegister')}
                  name="allowRegister"
                  required={true}
                  valuePropName="checked"
                >
                  <Switch className="custom-switch-primary" />
                </Form.Item>
              </Col>
              
              {/* 第二列：安全设置 */}
              <Col span={12}>
                {/* 杀毒设置 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.antivirusEnabled')}
                  name="antivirusEnabled"
                  valuePropName="checked"
                >
                  <Switch className="custom-switch-success" />
                </Form.Item>

                {/* 病毒扫描超时时间 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.virusScanTimeout', '病毒扫描超时(秒)')}
                  name="virusScanTimeoutSeconds"
                  rules={[
                    {
                      type: 'number',
                      min: 30,
                      max: 3600,
                      message: Lang.t('preference.virusScanTimeoutRange', '请输入30-3600之间的数字'),
                    },
                  ]}
                >
                  <InputNumber
                    min={30}
                    max={3600}
                    addonAfter={Lang.t('preference.second', '秒')}
                    className="w150"
                  />
                </Form.Item>

                {/* 新增：手动升级病毒库 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.antivirusUpdate')}
                  wrapperCol={{ span: 14, offset: 10 }}
                >
                  <Button 
                    type="default"
                    icon={<SyncOutlined spin={this.state.updatingVirusDb} />}
                    onClick={this.handleManualUpdate}
                    loading={this.state.updatingVirusDb}
                    className="mr10"
                  >
                    {Lang.t('preference.manualUpdate')}
                  </Button>
                  <span className="text-muted ml10">{Lang.t('preference.manualUpdateTip')}</span>
                </Form.Item>

                {/* 新增：内网上传病毒库 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.uploadVirusDb')}
                  wrapperCol={{ span: 14, offset: 10 }}
                >
                  <Upload
                    accept=".zip,.tar.gz,.tgz"
                    showUploadList={false}
                    beforeUpload={this.handleUploadVirusDb}
                    customRequest={({ file, onSuccess, onError }) => {
                      // 自定义上传，实际在上传前已处理，这里返回false阻止默认
                      return false;
                    }}
                  >
                    <Button 
                      icon={<UploadOutlined />} 
                      loading={this.state.uploadingVirusDb}
                    >
                      {Lang.t('preference.uploadPackage')}
                    </Button>
                  </Upload>
                  <span className="text-muted ml10">{Lang.t('preference.uploadVirusDbTip')}</span>
                </Form.Item>
                
                {/* 敏感词检查设置 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.fullTextSearchEnabled')}
                  name="fullTextSearchEnabled"
                  valuePropName="checked"
                >
                  <Switch className="custom-switch-warning" />
                </Form.Item>
                
                {that.formRef.current?.getFieldValue('fullTextSearchEnabled') && (
                  <Form.Item
                    {...layout}
                    label={Lang.t('preference.sensitiveWords')}
                    wrapperCol={{ span: 14, offset: 10 }}
                  >
                    <div className="mb10">
                      <Button 
                        type="primary" 
                        size="small"
                        className="btn-manage"
                        onClick={() => this.setState({ showSensitiveWordsModal: true })}
                      >
                        {Lang.t('preference.manageSensitiveWords')}
                      </Button>
                      
                      <Button 
                        icon={<ExportOutlined />} 
                        size="small" 
                        className="ml10 btn-export"
                        onClick={this.exportSensitiveWords}
                      >
                        {Lang.t('preference.export')}
                      </Button>
                      
                      <Upload 
                          showUploadList={false}
                          beforeUpload={(file) => {
                            this.handleSensitiveWordsFileUpload(file);
                            return false;
                          }}
                          accept=".csv"
                          multiple={false}
                        >
                          <Button 
                            icon={<ImportOutlined />} 
                            size="small" 
                            className="ml10 btn-import"
                          >
                            {Lang.t('preference.import')}
                          </Button>
                        </Upload>
                    </div>
                    
                    <div className="sensitive-words-preview">
                      {this.state.sensitiveWords.slice(0, 5).map(word => (
                        <Tag key={word} className="custom-tag">{word}</Tag>
                      ))}
                      {this.state.sensitiveWords.length > 5 && (
                        <Tag className="custom-tag-more">
                          +{this.state.sensitiveWords.length - 5} {Lang.t('preference.more')}
                        </Tag>
                      )}
                      {this.state.sensitiveWords.length === 0 && (
                        <span className="text-muted">{Lang.t('preference.noSensitiveWords')}</span>
                      )}
                    </div>
                  </Form.Item>
                )}

                {/* 扩展名过滤设置 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.forbiddenExtensionsEnabled')}
                  name="forbiddenExtensionsEnabled"
                  valuePropName="checked"
                >
                  <Switch className="custom-switch-danger" />
                </Form.Item>
                
                {that.formRef.current?.getFieldValue('forbiddenExtensionsEnabled') && (
                  <Form.Item
                    {...layout}
                    label={Lang.t('preference.forbiddenExtensions')}
                    wrapperCol={{ span: 14, offset: 10 }}
                  >
                    <div className="mb10">
                      <Button 
                        type="primary" 
                        size="small"
                        className="btn-manage"
                        onClick={() => this.setState({ showForbiddenExtensionsModal: true })}
                      >
                        {Lang.t('preference.manageForbiddenExtensions')}
                      </Button>
                      
                      <Button 
                        icon={<ExportOutlined />} 
                        size="small" 
                        className="ml10 btn-export"
                        onClick={this.exportForbiddenExtensions}
                      >
                        {Lang.t('preference.export')}
                      </Button>
                      
                      <Upload 
                        showUploadList={false}
                        beforeUpload={(file) => {
                          this.handleFileUpload(file);
                          return false;
                        }}
                        accept=".csv"
                        multiple={false}
                      >
                        <Button 
                          icon={<ImportOutlined />} 
                          size="small" 
                          className="ml10 btn-import"
                        >
                          {Lang.t('preference.import')}
                        </Button>
                      </Upload>
                    </div>
                    
                    <div className="forbidden-extensions-preview">
                      {/* 添加调试信息 */}
                      <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                        {Lang.t('preference.currentCount')}: {this.state.forbiddenExtensions.length}
                      </div>
                      
                      {this.state.forbiddenExtensions.slice(0, 5).map(ext => (
                        <Tag key={ext} className="custom-tag">.{ext}</Tag>
                      ))}
                      {this.state.forbiddenExtensions.length > 5 && (
                        <Tag className="custom-tag-more">
                          +{this.state.forbiddenExtensions.length - 5} {Lang.t('preference.more')}
                        </Tag>
                      )}
                      {this.state.forbiddenExtensions.length === 0 && (
                        <span className="text-muted">{Lang.t('preference.noForbiddenExtensions')}</span>
                      )}
                    </div>
                  </Form.Item>
                )}

                {/* 水印设置 */}
                <Form.Item
                  {...layout}
                  label={Lang.t('preference.watermarkEnabled')}
                  wrapperCol={{ span: 14, offset: 10 }}
                >
                  <div className="mb10">
                    <Switch 
                      checked={this.state.watermarkConfig.enabled}
                      onChange={(checked) => this.updateWatermarkConfig('enabled', checked)}
                      className="custom-switch-info"
                    />
                    <span className="pl10">
                      {this.state.watermarkConfig.enabled ? Lang.t('preference.enabled') : Lang.t('preference.disabled')}
                    </span>
                  </div>
                  
                  {this.state.watermarkConfig.enabled && (
                    <div>
                      <Button 
                        type="primary" 
                        size="small"
                        className="btn-manage"
                        onClick={() => this.setState({ showWatermarkModal: true })}
                      >
                        {Lang.t('preference.manageWatermark')}
                      </Button>
                      <Button 
                        icon={<EyeOutlined />} 
                        size="small" 
                        className="ml10 btn-preview"
                        onClick={this.previewWatermark}
                      >
                        {Lang.t('preference.preview')}
                      </Button>
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>

            <div className="text-right mt20">
              <Button type="primary" htmlType="submit" icon={<SaveOutlined />} className="btn-save">
                {Lang.t('save')}
              </Button>
            </div>
          </Form>
        </HwzContentCard>
        
        {/* 敏感词管理模态框 */}
        <Modal
          title={Lang.t('preference.manageSensitiveWords')}
          visible={this.state.showSensitiveWordsModal}
          onCancel={() => this.setState({ showSensitiveWordsModal: false })}
          footer={[
            <Button key="cancel" className="btn-cancel" onClick={() => this.setState({ showSensitiveWordsModal: false })}>
              {Lang.t('close')}
            </Button>
          ]}
          width={600}
        >
          <div className="mb10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <Input
              value={this.state.newSensitiveWord}
              onChange={e => this.setState({ newSensitiveWord: e.target.value })}
              placeholder={Lang.t('preference.enterSensitiveWord')}
              onPressEnter={this.addSensitiveWord}
              className="w200"
              style={{ marginRight: '15px' }}
            />
            <Button 
              type="primary" 
              onClick={this.addSensitiveWord}
              className="btn-add"
            >
              {Lang.t('preference.add')}
            </Button>
          </div>
          
          <div className="sensitive-words-list">
            {this.state.sensitiveWords.map(word => (
              <Tag 
                key={word} 
                closable 
                onClose={() => this.removeSensitiveWord(word)}
                className="mb5 custom-tag"
              >
                {word}
              </Tag>
            ))}
            
            {this.state.sensitiveWords.length === 0 && (
              <div className="text-muted">{Lang.t('preference.noSensitiveWords')}</div>
            )}
          </div>
        </Modal>

        {/* 禁止扩展名管理模态框 */}
        <Modal
          title={Lang.t('preference.manageForbiddenExtensions')}
          visible={this.state.showForbiddenExtensionsModal}
          onCancel={() => this.setState({ showForbiddenExtensionsModal: false })}
          footer={[
            <Button key="cancel" className="btn-cancel" onClick={() => this.setState({ showForbiddenExtensionsModal: false })}>
              {Lang.t('close')}
            </Button>
          ]}
          width={600}
        >
          <div className="mb10" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <Input
              value={this.state.newForbiddenExtension}
              onChange={e => this.setState({ newForbiddenExtension: e.target.value })}
              placeholder={Lang.t('preference.enterForbiddenExtension')}
              onPressEnter={this.addForbiddenExtension}
              className="w200"
              style={{ marginRight: '15px' }}
              addonBefore="."
            />
            <Button 
              type="primary" 
              onClick={this.addForbiddenExtension}
              className="btn-add"
            >
              {Lang.t('preference.add')}
            </Button>
          </div>
          
          <div className="forbidden-extensions-list">
            {this.state.forbiddenExtensions.map(ext => (
              <Tag 
                key={ext} 
                closable 
                onClose={() => this.removeForbiddenExtension(ext)}
                className="mb5 custom-tag"
              >
                .{ext}
              </Tag>
            ))}
            
            {this.state.forbiddenExtensions.length === 0 && (
              <div className="text-muted">{Lang.t('preference.noForbiddenExtensions')}</div>
            )}
          </div>
        </Modal>

        {/* 水印配置模态框 */}
        <Modal
          title={Lang.t('preference.manageWatermark')}
          visible={this.state.showWatermarkModal}
          onCancel={() => this.setState({ showWatermarkModal: false })}
          footer={[
            <Button key="cancel" className="btn-cancel" onClick={() => this.setState({ showWatermarkModal: false })}>
              {Lang.t('close')}
            </Button>
          ]}
          width={700}
        >
          <div className="watermark-config-form">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={Lang.t('preference.watermarkText')}>
                  <Input
                    value={this.state.watermarkConfig.text}
                    onChange={e => this.updateWatermarkConfig('text', e.target.value)}
                    placeholder={Lang.t('preference.enterWatermarkText')}
                  />
                </Form.Item>

                <Form.Item label={Lang.t('preference.watermarkFontSize')}>
                  <InputNumber
                    value={this.state.watermarkConfig.fontSize}
                    onChange={value => this.updateWatermarkConfig('fontSize', value)}
                    min={12}
                    max={72}
                    className="w100"
                  />
                </Form.Item>

                <Form.Item label={Lang.t('preference.watermarkOpacity')}>
                  <InputNumber
                    value={this.state.watermarkConfig.opacity}
                    onChange={value => this.updateWatermarkConfig('opacity', value)}
                    min={0.1}
                    max={1}
                    step={0.1}
                    className="w100"
                  />
                </Form.Item>

                <Form.Item label={Lang.t('preference.watermarkRotate')}>
                  <InputNumber
                    value={this.state.watermarkConfig.rotate}
                    onChange={value => this.updateWatermarkConfig('rotate', value)}
                    min={-90}
                    max={90}
                    className="w100"
                  />
                </Form.Item>

                <Form.Item label={Lang.t('preference.watermarkColor')}>
                  {this.renderColorSelect()}
                </Form.Item>
              </Col>
              
              <Col span={12}>
                {/* 修改 showUser Switch 组件，添加调试日志 */}
                <Form.Item label={Lang.t('preference.showUsername')}>
                  <Switch
                    checked={this.state.watermarkConfig.showUser}
                    onChange={(checked) => {
                      console.log('showUser Switch changed to:', checked);
                      this.updateWatermarkConfig('showUser', checked);
                    }}
                  />
                  <span style={{ marginLeft: 8 }}>
                    {this.state.watermarkConfig.showUser ? 
                      Lang.t('preference.enabled') : 
                      Lang.t('preference.disabled')}
                  </span>
                </Form.Item>

                <Card size="small" title={Lang.t('preference.fileTypeSpecific')} className="mt10">
                  <Form.Item label={Lang.t('preference.pdfWatermarkText')}>
                    <Input
                      value={this.state.watermarkConfig.pdfText}
                      onChange={e => this.updateWatermarkConfig('pdfText', e.target.value)}
                      placeholder={Lang.t('preference.enterPdfWatermarkText')}
                    />
                  </Form.Item>

                  <Form.Item label={Lang.t('preference.pdfWatermarkColor')}>
                    {this.renderPdfColorSelect()}
                  </Form.Item>

                  <Form.Item label={Lang.t('preference.imageWatermarkText')}>
                    <Input
                      value={this.state.watermarkConfig.imageText}
                      onChange={e => this.updateWatermarkConfig('imageText', e.target.value)}
                      placeholder={Lang.t('preference.enterImageWatermarkText')}
                    />
                  </Form.Item>

                  <Form.Item label={Lang.t('preference.imageWatermarkOpacity')}>
                    <InputNumber
                      value={this.state.watermarkConfig.imageOpacity}
                      onChange={value => this.updateWatermarkConfig('imageOpacity', value)}
                      min={0.1}
                      max={1}
                      step={0.1}
                      className="w100"
                    />
                  </Form.Item>

                  <Form.Item label={Lang.t('preference.documentWatermarkText')}>
                    <Input
                      value={this.state.watermarkConfig.documentText}
                      onChange={e => this.updateWatermarkConfig('documentText', e.target.value)}
                      placeholder={Lang.t('preference.enterDocumentWatermarkText')}
                    />
                  </Form.Item>
                </Card>
              </Col>
            </Row>

            <div className="text-center mt20">
              <Button 
                type="primary" 
                icon={<EyeOutlined />}
                onClick={this.previewWatermark}
              >
                {Lang.t('preference.previewWatermark')}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}